/**
 * PhotoUploadCard
 * Fotoğraf yükleme kartı
 */

import React, { useRef } from 'react';
import { Camera, X, RefreshCw } from 'lucide-react';

export default function PhotoUploadCard({
  image,
  onUpload,
  onRemove,
  title,
  subtitle,
  required = false,
  disabled = false
}) {
  const inputRef = useRef(null);
  
  const handleClick = () => {
    if (!disabled) {
      inputRef.current?.click();
    }
  };
  
  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onUpload(file);
    }
    // Reset input
    e.target.value = '';
  };
  
  const handleRemove = (e) => {
    e.stopPropagation();
    onRemove?.();
  };
  
  const handleReplace = (e) => {
    e.stopPropagation();
    inputRef.current?.click();
  };
  
  return (
    <div 
      className={`oracle-glass-card oracle-upload-card ${image ? 'has-image' : ''}`}
      onClick={handleClick}
      style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleChange}
        style={{ display: 'none' }}
        disabled={disabled}
      />
      
      {image ? (
        <>
          <img src={image} alt={title} />
          <div className="oracle-upload-actions">
            <button className="oracle-upload-action-btn" onClick={handleReplace}>
              <RefreshCw size={14} />
            </button>
            <button className="oracle-upload-action-btn" onClick={handleRemove}>
              <X size={14} />
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="oracle-upload-icon">
            <Camera size={48} strokeWidth={1.5} />
          </div>
          <div className="oracle-upload-text">{title}</div>
          {subtitle && (
            <div className="oracle-upload-hint">
              {subtitle}
              {required && <span style={{ color: '#ef4444' }}> *</span>}
            </div>
          )}
        </>
      )}
    </div>
  );
}
